import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings-client',
  templateUrl: './settings-client.component.html',
  styleUrls: ['./settings-client.component.css', '../../styles/sidebar.css']
})
export class SettingsClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/settings-client/settings-client.component.ts